<wre-toolkit-modal-popup [title]="title"
                         [hideFooter]="true"
>
  {{ message }}
</wre-toolkit-modal-popup>
